import axios from 'axios'

export default axios.create({
    baseURL: 'https://off.radiokrakow.pl/api/index.php/',
    crossDomain: true,
    headers: {
        'Content-Type': 'application/json',
    }
})